import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import DaohuuLayoutComponent from '@app/pages/FUtil/DaohuuLayoutComponent';
import {Button, Modal} from "react-bootstrap";
import {myService} from '@app/services/daohuuService';
import DaohuuAutocompleteComponent from '@app/pages/FUtil/DaohuuAutocompleteComponent';
import MoiquanheListComponent from '@app/pages/FUtil/MoiquanheListComponent';
import {alertService} from '@app/services/alertService';
import {ClipLoader} from "react-spinners";

const ThannhanEdit = ({id}) => {
    const [loading, setLoading] = useState(false);
    const [handleToogle, setHandleToogle] = useState(false);
    const [t] = useTranslation();
    const [thannhanList, setThannhanList] = useState([]);
    const initial = {
        thannhanObj: null, // gọi trên BE tương tự daohuuObj
        moiquanhe_fk: null
    }
    const [isViewThannhan, setIsViewThannhan] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [obj, setObj] = useState({...initial});

    // Helper function to get relationship icon
    const getRelationshipIcon = (moiQuanHe) => {
        if (!moiQuanHe || typeof moiQuanHe !== 'string') {
            return 'fas fa-users text-muted';
        }

        const relation = moiQuanHe.toLowerCase();
        if (relation.includes('cha') || relation.includes('bố')) {
            return 'fas fa-male text-primary';
        } else if (relation.includes('mẹ') || relation.includes('má')) {
            return 'fas fa-female text-danger';
        } else if (relation.includes('con')) {
            return 'fas fa-child text-success';
        } else if (relation.includes('anh') || relation.includes('em') || relation.includes('chị')) {
            return 'fas fa-user-friends text-info';
        } else if (relation.includes('vợ') || relation.includes('chồng')) {
            return 'fas fa-heart text-danger';
        } else {
            return 'fas fa-users text-muted';
        }
    };

    const saveClick = async () => {
        let data = obj;
        if (!data) {
            alert('Không xác định được trang vui lòng tải lại');
            return;
        }

        if (!data.moiquanhe_fk || data.moiquanhe_fk.length === 0) {
            alert('Vui lòng chọn mối quan hệ');
            return;
        }
        if (!data.thannhanObj) {
            alert('Vui lòng chọn đạo hữu có mối quan hệ');
            return;
        }

        create(data);
    };

    const loadRef = async (action) => {
        try {
            if (action === 'daohuu_thannhan') {
                const tmp = await myService.getRefById(id, action, {});
                setThannhanList(tmp || []); // Đảm bảo luôn có array
                setIsViewThannhan(true);
            } else {
                alert('Chức năng chưa hỗ trợ');
            }
        } catch (error) {
            console.error("Lỗi khi load dữ liệu:", error);
            alert('Có lỗi xảy ra khi tải dữ liệu');
            setThannhanList([]);
        }

        setHandleToogle((prevSelected) => {
            return !prevSelected;
        });
    };

    const deletedonhang = async (rowIndex) => {
        try {
            const {id: itemId} = thannhanList[rowIndex];
            const result = await myService.Delete(itemId);
            if (result.status === "1") {
                alertService.success(t('fields.label.xoathanhcong'));
                await loadRef('daohuu_thannhan');
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            console.error("Lỗi khi xóa thân nhân:", error);
            alertService.error('Có lỗi xảy ra khi xóa thân nhân');
        }
    };

    const onChangeInput = (e) => {
        const {name, value, checked} = e.target;

        setObj((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    useEffect(() => {
        loadRef('daohuu_thannhan');
    }, []);

    async function create(data) {
        setLoading(true);
        try {
            const result = await myService.Create_Thannhan(id, data);
            if (result.status === "1") {
                alertService.success(result.msg);
                await loadRef('daohuu_thannhan');
                setShowModal(false);
                setIsViewThannhan(true);
            } else {
                alertService.error(result.msg);
            }
        } catch (error) {
            console.error("Lỗi khi tạo thân nhân:", error);
            alertService.error("Có lỗi xảy ra khi thêm thân nhân");
        }
        setLoading(false);
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-40">
                <ClipLoader color="#3498db" size={50}/>
            </div>
        );
    }

    return <>
        {isViewThannhan ? (
            <Button
                className="btn btn-secondary  mr-1"
                aria-label="Close"
                onClick={() => {
                    setIsViewThannhan(false);
                    setThannhanList([]);
                }}
            >
                <span aria-hidden="true">Ẩn</span>
            </Button>
        ) : (
            <Button className="btn btn-info  mr-1" onClick={() => loadRef('daohuu_thannhan')}>
                <i className="fa fa-arrow-down"> {"Xem"}</i>
            </Button>
        )}

        {isViewThannhan && (
            <Button
                className="btn  btn-success  mr-1"
                icon="right fas fa-angle-left"
                onClick={() => {
                    setShowModal(true);
                    setObj({...initial});
                }}
            >
                <i className="fa fa-save"> {"Thêm"} </i>
            </Button>
        )}

        <hr/>

        {isViewThannhan && (
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">
                                <i className="fas fa-users mr-2"></i>
                                Danh sách thân nhân
                            </h5>
                        </div>
                        <div className="card-body p-0">
                            <div className="table-responsive">
                                <table className="table table-hover table-striped mb-0">
                                    <thead className="thead-light">
                                    <tr>
                                        <th className="text-center" style={{width: '80px'}}>
                                            <i className="fas fa-user"></i>
                                        </th>
                                        <th>Thông tin thân nhân</th>
                                        <th className="text-center" style={{width: '150px'}}>Mối quan hệ</th>
                                        <th className="text-center" style={{width: '100px'}}>Thao tác</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        thannhanList && thannhanList.length > 0 ? thannhanList.map((item, index) => {
                                            return (
                                                <tr key={index} className="align-middle">
                                                    <td className="text-center p-2">
                                                        <div className="avatar-placeholder d-flex align-items-center justify-content-center"
                                                             style={{
                                                                 width: '60px',
                                                                 height: '60px',
                                                                 backgroundColor: '#f8f9fa',
                                                                 borderRadius: '50%',
                                                                 border: '2px solid #dee2e6'
                                                             }}>
                                                            <i className={getRelationshipIcon(item.moi_quan_he)}
                                                               style={{fontSize: '24px'}}></i>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <DaohuuLayoutComponent
                                                            currentSuggestion={item}
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="badge badge-outline-primary p-2">
                                                            <i className={getRelationshipIcon(item.moi_quan_he)}
                                                               style={{fontSize: '14px', marginRight: '5px'}}></i>
                                                            {item.moi_quan_he || '-'}
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <button
                                                            className="btn btn-outline-danger btn-sm"
                                                            title="Xóa thân nhân"
                                                            onClick={() => {
                                                                if (window.confirm(t('fields.label.bancomuonxoa'))) {
                                                                    deletedonhang(index);
                                                                }
                                                            }}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="4" className="text-center text-muted py-4">
                                                    <i className="fas fa-users fa-2x mb-2"></i>
                                                    <div>Chưa có thân nhân nào</div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        <Modal size="lg" show={showModal} onHide={() => {
            setShowModal(false)
        }}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fas fa-user-plus mr-2"></i>
                    Thông tin thân nhân
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='form-group'>
                    <label htmlFor="thannhanObj" className="font-weight-bold">
                        <i className="fas fa-user mr-1"></i>Đạo hữu
                    </label>
                    <DaohuuAutocompleteComponent
                        currentSuggestion={obj.thannhanObj}
                        onChange={(e) => {
                            const target = {name: 'thannhanObj', value: e?.value};
                            onChangeInput({target})
                        }}
                    />
                    <small className="form-text text-muted">
                        Chọn đạo hữu có mối quan hệ thân nhân
                    </small>
                </div>

                <div className='form-group'>
                    <MoiquanheListComponent
                        moiquanhe_fk={obj.moiquanhe_fk}
                        onChange={(opt, e) => {
                            const target = {name: "moiquanhe_fk", value: opt?.value};
                            onChangeInput({target});
                        }}
                    />
                    <small className="form-text text-muted">
                        Chọn mối quan hệ với người này
                    </small>
                </div>

                {/* Preview thông tin đã chọn */}
                {obj.thannhanObj && obj.moiquanhe_fk && (
                    <div className="alert alert-info">
                        <h6 className="alert-heading">
                            <i className="fas fa-info-circle mr-2"></i>Thông tin xem trước
                        </h6>
                        <div className="d-flex align-items-center">
                            <i className={getRelationshipIcon(obj.moiquanhe_fk)}
                               style={{fontSize: '24px', marginRight: '10px'}}></i>
                            <div>
                                <strong>{obj.thannhanObj.ten || 'Chưa có tên'}</strong>
                                <br/>
                                <small className="text-muted">
                                    Mối quan hệ: {obj.moiquanhe_fk}
                                </small>
                            </div>
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    setShowModal(false);
                }}>
                    <i className="fas fa-times mr-2"></i>
                    Thoát
                </Button>
                <Button variant="primary" onClick={saveClick}>
                    <i className="fas fa-check mr-2"></i>
                    Xác nhận
                </Button>
            </Modal.Footer>
        </Modal>
    </>
};

export default ThannhanEdit;